import "@/App.css";
import "@/InvestorDeck.css";
import InvestorsPage from "@/pages/InvestorsPage";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { LeadProvider } from "@/context/LeadContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Layout from "@/components/Layout";
import LandingPage from "@/pages/LandingPage";
import DivisionPage from "@/pages/DivisionPage";
import SolutionPage from "@/pages/SolutionPage";
import AboutPage from "@/pages/AboutPage";
import TechnologyPage from "@/pages/TechnologyPage";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function AdminSplash({ label }) {
  return (
    <div className="adm-splash">
      <div className="adm-spinner" />
      <p>{label}</p>
    </div>
  );
}

function ProtectedAdmin() {
  const { user, loading } = useAuth();
  if (loading) return <AdminSplash label="Loading…" />;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role !== "admin") {
    return (
      <div className="adm-splash">
        <p>Your account (<strong>{user.email}</strong>) is not authorized for the admin console.</p>
      </div>
    );
  }
  return <AdminDashboard />;
}

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/division/:key" element={<DivisionPage />} />
        <Route path="/solutions/:key" element={<SolutionPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/technology" element={<TechnologyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/investors" element={<InvestorsPage />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedAdmin />} />
    </Routes>
  );
}

function App() {
  return (
    <LeadProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </LeadProvider>
  );
}

export default App;
